import React from 'react';
import { COMPANY_INFO } from '../utils/constants';
import './LegalPages.css';

const PrivacyPolicy: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy - Pickup Rental Truck Dubai",
    "description": "Privacy Policy for Pickup Rental Truck Dubai. Learn how we collect, use, and protect your personal information.",
    "url": `${COMPANY_INFO.website}/privacy-policy`,
    "isPartOf": {
      "@type": "WebSite",
      "name": COMPANY_INFO.name,
      "url": COMPANY_INFO.website
    }
  };

  return (
    <div className="legal-page">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              {COMPANY_INFO.name} ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your 
              information when you visit our website or use our pickup truck rental services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li>Name and contact information (email address, phone number)</li>
              <li>Address and location information</li>
              <li>Payment information (processed securely through third-party providers)</li>
              <li>Service preferences and requirements</li>
              <li>Communication records and correspondence</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>We may automatically collect certain information when you visit our website:</p>
            <ul>
              <li>IP address and device information</li>
              <li>Browser type and version</li>
              <li>Pages visited and time spent on our website</li>
              <li>Referring website information</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for the following purposes:</p>
            <ul>
              <li>Providing and improving our pickup truck rental services</li>
              <li>Processing bookings and managing reservations</li>
              <li>Communicating with you about services and updates</li>
              <li>Processing payments and billing</li>
              <li>Customer support and service delivery</li>
              <li>Marketing and promotional communications (with your consent)</li>
              <li>Legal compliance and regulatory requirements</li>
              <li>Website analytics and performance improvement</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We may share your information in the following circumstances:</p>
            <ul>
              <li><strong>Service Providers:</strong> With third-party service providers who assist in our operations</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales</li>
              <li><strong>Consent:</strong> With your explicit consent for specific purposes</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your 
              personal information against unauthorized access, alteration, disclosure, or 
              destruction. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2>6. Cookies and Tracking Technologies</h2>
            <p>
              Our website uses cookies and similar technologies to enhance your browsing 
              experience, analyze website traffic, and personalize content. You can control 
              cookie settings through your browser preferences.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ul>
              <li>Access and review your personal data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Data portability rights</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
          </section>

          <section>
            <h2>8. Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill 
              the purposes outlined in this Privacy Policy, unless a longer retention period 
              is required by law.
            </p>
          </section>

          <section>
            <h2>9. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible 
              for the privacy practices or content of these external sites. We encourage you 
              to review their privacy policies.
            </p>
          </section>

          <section>
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are not directed to children under 13 years of age. We do not 
              knowingly collect personal information from children under 13.
            </p>
          </section>

          <section>
            <h2>11. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than 
              your country of residence. We ensure appropriate safeguards are in place for 
              such transfers.
            </p>
          </section>

          <section>
            <h2>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of 
              any material changes by posting the new Privacy Policy on this page and 
              updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2>13. Contact Information</h2>
            <p>
              If you have any questions about this Privacy Policy or our privacy practices, 
              please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> mkashiff6@gmail.com</p>
              <p><strong>Phone:</strong> 0543507981</p>
              <p><strong>Address:</strong> Al Quoz 4 Industrial Area, Dubai, UAE</p>
            </div>
          </section>
        </div>
      </div>
  );
};

export default PrivacyPolicy;
